import { render, staticRenderFns } from "./creativeDesignRosiPicture.vue?vue&type=template&id=5489948a&scoped=true&"
import script from "./creativeDesignRosiPicture.vue?vue&type=script&lang=js&"
export * from "./creativeDesignRosiPicture.vue?vue&type=script&lang=js&"
import style0 from "./creativeDesignRosiPicture.vue?vue&type=style&index=0&id=5489948a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489948a",
  null
  
)

component.options.__file = "creativeDesignRosiPicture.vue"
export default component.exports